import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { api } from '../../../services/api';
import { sortAlphabetical } from '../../../utils/utils';

import './merchant-dropdown.scss';

class MerchantDropdown extends Component {
	constructor(props) {
		super(props);

		this.Api = api;

		this.dropdownNode = null;

		this.state = {
			merchants: [],
			merchantList: [],
			opened: false,
			selectedMerchant: 'Select Merchant',
			searchTerm: '',
		};
	}

	componentWillUnmount() {
		window.removeEventListener('click', this.handleClick.bind(this), false);
	}

	componentDidMount() {
		window.addEventListener('click', this.handleClick.bind(this), false);

		this.getMerchants();
	}

	handleClick(event) {
		if (this.dropdownNode && !this.dropdownNode.contains(event.target)) {
			this.dropdownNode.classList.remove('open');
		}
	}

	getMerchants() {
		return this.Api.get(`/api/v0/merchants/`).then((resp) => {
			const info = resp.data.data.length ? resp.data.data : [];
			return {merchants: info};
		}).then(({ merchants }) => {
			sortAlphabetical(merchants, 'full_name');
			this.setState({
				merchants: merchants,
				merchantList: merchants,
			});
		});
	}

	toggleDropdown() {
		this.setState({opened: !this.state.opened});
	}

	handleSearchChange(event) {
		this.filterMerchantsByName(event.target.value);
	}

	filterMerchantsByName(searchTerm) {
		const merchants = this.state.merchants.filter((merchant) => {
			const name = merchant.full_name || '';
			return name.toLowerCase().startsWith(searchTerm.toLowerCase());
		});
		this.setState({
			merchantList: merchants,
			searchTerm: searchTerm,
		});
	}

	selectMerchant(merchant) {
		this.setState({
			selectedMerchant: merchant.full_name,
			opened: false,
		});

		this.props.setMerchant(merchant);
	}

	render() {
		return (
			<div ref={(node) => this.dropdownNode = node}
				className={`merchant-dropdown 
				${this.state.opened ? 'open' : 'closed'}`}>
				<div className="dropdown-toggle"
					 tabIndex={0}
					 onClick={this.toggleDropdown.bind(this)}>
					<span>{this.state.selectedMerchant}</span>
					<span className="narrativ-icon down"></span>
				</div>
				<ul className="dropdown-menu">
					<li className="search-input">
						<span className="narrativ-icon search"></span>
						<input
							type="text"
							placeholder="Search"
							value={this.state.searchTerm}
							onChange={this.handleSearchChange.bind(this)}
						/>
					</li>

					{this.state.merchantList.map((merchant, idx) => {
						return (
							<li key={idx}
								className="merchant"
								onClick={() => this.selectMerchant(merchant)}>
								{merchant.full_name}
							</li>
						);
					})}
				</ul>
			</div>
		);
	}
}

export default withRouter(MerchantDropdown);
